import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/AuthService';

const useAuthViewModel = () => {
  const navigate = useNavigate();
  const [hasLogin, setHasLogin] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState(AuthService.getCurrentEmail());

  const login = async (email, password) => {
    setLoading(true);
    setError(null);
    try {
      const data = await AuthService.login(email, password);
      setEmail(data);
      return true;
    } catch (err) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    AuthService.logout();
    setEmail(null);
    setHasLogin(false);
  };
  
  useEffect(() => {
    setEmail(AuthService.getCurrentEmail());
  });

  useEffect(() => {
    if (!email && hasLogin) {
      setHasLogin(false);
      AuthService.logout();
      alert('Authentication expired. Please log in again.');
      navigate('/login');
    }
    if (email && !hasLogin) {
      setHasLogin(true);
    }
  }, [email, hasLogin]);

  return {
    email,
    loading,
    error,
    login,
    logout,
  };
};

export default useAuthViewModel;